export const ADD_PRODUCT = "ADD_PRODUCT";
export const REMOVE_PRODUCT = "REMOVE_PRODUCT";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const TOGGLE_BUY_MODAL = "TOGGLE_BUY_MODAL";
export const NEXT_PAGE = "NEXT_PAGE";
export const PREVIOUS_PAGE = "PREVIOUS_PAGE";
export const SET_GROUPE_TYPE = "SET_GROUPE_TYPE";
export const SAVE_NEW_CIRCLE_DETAILS = "SAVE_NEW_CIRCLE_DETAILS";
 